/* Saukhya V2 — Homepage mini-quiz logic */
(function () {
  'use strict';

  var qStep = 1;
  var qAnswers = {};

  function pick(btn) {
    var s = btn.dataset.s;
    document.querySelectorAll('.q-opt[data-s="' + s + '"]').forEach(function (b) {
      b.classList.remove('sel');
    });
    btn.classList.add('sel');
    qAnswers[s] = btn.textContent.trim();
    var nxt = document.getElementById('qn' + qStep);
    if (nxt) nxt.classList.add('on');
  }

  function goNext(from) {
    var curr = document.getElementById('qs' + from);
    if (curr) curr.classList.remove('active');
    qStep = from + 1;
    var next = document.getElementById('qs' + qStep);
    if (next) next.classList.add('active');
  }

  function goBack(current) {
    var curr = document.getElementById('qs' + current);
    if (curr) curr.classList.remove('active');
    qStep = current - 1;
    var prev = document.getElementById('qs' + qStep);
    if (prev) prev.classList.add('active');
  }

  function showRes() {
    var s3 = document.getElementById('qs3');
    if (s3) s3.classList.remove('active');
    var res = document.getElementById('qres');
    if (res) res.classList.add('show');
  }

  function resetQ() {
    var res = document.getElementById('qres');
    if (res) res.classList.remove('show');
    document.querySelectorAll('.qstep').forEach(function (s) { s.classList.remove('active'); });
    document.querySelectorAll('.q-opt').forEach(function (o) { o.classList.remove('sel'); });
    document.querySelectorAll('.q-next').forEach(function (b) { b.classList.remove('on'); });
    qStep = 1;
    qAnswers = {};
    var qs1 = document.getElementById('qs1');
    if (qs1) qs1.classList.add('active');
  }

  /* Expose globally so inline onclick attributes work */
  window.svPick   = pick;
  window.svNext   = goNext;
  window.svBack   = goBack;
  window.svShow   = showRes;
  window.svReset  = resetQ;
})();
